module.exports = __webpack_public_path__ + "img/TheMJ_typo.0a3618ea.png";